export interface VideoPlayerControlsOptions {
  playLabel?: string;
  pauseLabel?: string;
  muteLabel?: string;
  unmuteLabel?: string;
  iconsPath?: string;
}

/**
 * Generates Plyr controls HTML string.
 * Mirrors VideoPlayer.php::getControlsHtml() from the Blade implementation.
 */
export function useVideoPlayerControlsHtml(options: VideoPlayerControlsOptions = {}): string {
  const {
    playLabel = 'Play',
    pauseLabel = 'Pause',
    muteLabel = 'Mute',
    unmuteLabel = 'Unmute',
    iconsPath = window.Phoenix?.iconsPath ?? '',
  } = options;

  return `
<div class="plyr__controls">
  <button type="button" data-plyr="mute" class="plyr__control phxsg-btn phxsg-btn--ghost phxsg-btn--icon-only">
    <svg class="phxsg-icon phxsg-icon--sound icon--not-pressed" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="${iconsPath}#sound"></use>
    </svg>
    <svg class="phxsg-icon phxsg-icon--sound-mute icon--pressed" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="${iconsPath}#sound-mute"></use>
    </svg>
    <span class="plyr__sr-only label--pressed">${unmuteLabel}</span>
    <span class="plyr__sr-only label--not-pressed">${muteLabel}</span>
  </button>
  <button type="button" data-plyr="play" class="plyr__control phxsg-btn phxsg-btn--ghost phxsg-btn--icon-only">
    <svg class="phxsg-icon phxsg-icon--phxsg-pause icon--pressed" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="${iconsPath}#phxsg-pause"></use>
    </svg>
    <svg class="phxsg-icon phxsg-icon--phxsg-play icon--not-pressed" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="${iconsPath}#phxsg-play"></use>
    </svg>
    <span class="plyr__sr-only label--pressed">${pauseLabel}</span>
    <span class="plyr__sr-only label--not-pressed">${playLabel}</span>
  </button>
</div>
  `.trim();
}
